import React from "react";
import { Radio } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import moment from "moment";
import numeral from "numeral";
import { renderStatus } from "../../../../libs/deadlinesUtils";

const ChoiceDeadlineToSplit = ({
  deadlinesToReconcile,
  openDeadlineDetail,
  setDeadlineToSplit,
  defaultValueToSplit,
  setDefaultValueToSplit
}) => {
  const onChangeRadio = e => {
    setDefaultValueToSplit(e.target.value);
    setDeadlineToSplit(e.target.value);
  };

  return (
    <>
      <Radio.Group onChange={onChangeRadio} value={defaultValueToSplit}>
        {deadlinesToReconcile.map((deadline, index) => {
          return (
            <div key={`deadlinesToReconcile_${index}`} className="dbx-reconciliation-deadline-split-row">
              <Radio
                value={deadline}
                className="dbx-reconciliation-deadline-split-radio"
              >
                <div
                  className={
                    "dbx-reconciliation-deadline-split-main-info-container"
                  }
                >
                  <div className="dbx-recinciliation-deadline-split-internal-block first-block">
                    <div
                      className={
                        "dbx-reconciliation-deadline-split-icon-container"
                      }
                    >
                      <FontAwesomeIcon
                        icon={["far", "alarm-clock"]}
                        style={{
                          color: "rgb(21, 41, 53)",
                          fontSize: "14px",
                          marginRight: "15px"
                        }}
                      />
                    </div>
                    <span
                      className={
                        "dbx-reconciliation-deadline-split-description dbx-reconciliation-deadline-split-date"
                      }
                    >
                      {moment(deadline?.date).format("DD MMM YY")}
                    </span>
                    <span
                      className={
                        "dbx-reconciliation-deadline-split-description dbx-reconciliation-truncate"
                      }
                    >
                      {deadline?.description?.title}
                    </span>
                  </div>
                  <div className="dbx-recinciliation-deadline-split-internal-block second-block">
                    <span
                      className={
                        "dbx-reconciliation-deadline-split-description flexContainer dbx-reconciliation-deadline-split-description-price"
                      }
                    >
                      <div
                        className={
                          "dbx-reconciliation-deadline-split-icon-amount-container"
                        }
                      >
                        <FontAwesomeIcon
                          icon={[
                            "fas",
                            deadline?.totalAmount < 0
                              ? "minus-circle"
                              : "plus-circle"
                          ]}
                          className={
                            deadline?.totalAmount < 0
                              ? "dbx-reconciliation-deadline-split-amount amountMinusIcon"
                              : " dbx-reconciliation-deadline-split-amount amountPlusIcon"
                          }
                        />{" "}
                      </div>
                      {`${numeral(Math.abs(deadline?.totalAmount)).format("0,0.00")} €`}
                    </span>
                    <div className="dbx-reconciliation-deadline-split-status-block">
                      <span
                        className={
                          "dbx-reconciliation-deadline-split-description"
                        }
                      >
                        {" "}
                        {deadline ? renderStatus(deadline) : null}{" "}
                      </span>
                      <FontAwesomeIcon
                        icon={["far", "eye"]}
                        className={"dbx-reconciliation-deadline-split-eye-icon"}
                        onClick={e => {
                          e.stopPropagation();
                          openDeadlineDetail(deadline.id);
                        }}
                      />
                    </div>
                  </div>
                </div>
              </Radio>
            </div>
          );
        })}
      </Radio.Group>
    </>
  );
};

export default ChoiceDeadlineToSplit;
